import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Space, Table } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import { TARGET_LEGEND_COMPETITION_HALF } from '../../../utils/constants';
import { getTargetLegends } from '../../../redux/selectors';

const TournamentLegend = () => {
  const targetLegends = useSelector(getTargetLegends);
  const [allShown, setAllShown] = useState(false);
  const legendsFormatTableData = targetLegends.map(
    (
      targetLegend: {
        categoryName: string;
        optionName: string;
        color: string;
        rounds: object[];
        enrolledCount: number;
        teamPlayerCount: number;
      },
      index: number
    ) => {
      const { categoryName, optionName, color, rounds } = targetLegend;

      return {
        key: `${categoryName}-${optionName}-${index}`,
        project: `${categoryName}${optionName}`,
        rounds,
        color,
        enrolledCount: targetLegend.enrolledCount,
        teamPlayerCount: targetLegend.teamPlayerCount,
      };
    }
  );
  const columns = [
    {
      title: '项目',
      dataIndex: 'project',
      key: 'project',
      className: 'TournamentLegendProjectColumn',
      width: 250,
      render: (project: string, record: any) => {
        const { color, enrolledCount, teamPlayerCount } = record;
        const playerCountString =
          teamPlayerCount <= 1 ? `${enrolledCount}人` : `${enrolledCount}队`;

        return (
          <span style={{ color }}>
            {project} ({playerCountString})
          </span>
        );
      },
    },
    {
      title: '比赛阶段',
      dataIndex: 'rounds',
      key: 'rounds',
      className: 'TournamentLegendProjectColumn',
      render: (rounds: any[], record: any) => {
        const { categoryName, optionName, color } = record;

        return (
          <Space className="flex flex-middle">
            {rounds.map((round, index) => {
              const { roundName, competitionHalf, isSelected } = round;
              const style = isSelected
                ? {
                    backgroundColor: color,
                    color: 'white',
                  }
                : {
                    color,
                  };

              if (
                competitionHalf === TARGET_LEGEND_COMPETITION_HALF.FIRSTHALF
              ) {
                return (
                  <i
                    className="TournamentLegendRoundName"
                    key={`${categoryName}-${optionName}-${roundName}-${index}`}
                    style={style}
                  >
                    {`${roundName}(上)`}
                  </i>
                );
              } else if (
                competitionHalf === TARGET_LEGEND_COMPETITION_HALF.SECONDHALF
              ) {
                return (
                  <i
                    className="TournamentLegendRoundName"
                    key={`${categoryName}-${optionName}-${roundName}-${index}`}
                    style={style}
                  >
                    {`${roundName}(下)`}
                  </i>
                );
              }

              return (
                <i
                  className="TournamentLegendRoundName"
                  key={`${categoryName}-${optionName}-${roundName}-${index}`}
                  style={style}
                >
                  {roundName}
                </i>
              );
            })}
          </Space>
        );
      },
    },
  ];
  const handleAllShownButtonClick = useCallback(() => {
    setAllShown(!allShown);
  }, [allShown]);

  return (
    <section
      id="TournamentLegend"
      className="TournamentLegend flex flex-middle flex-space-between"
    >
      <Table
        bordered={false}
        pagination={false}
        className={`TournamentLegendTable flex__fluid-content${
          legendsFormatTableData.length > 4
            ? ' TournamentLegendTableAllShownAnimationInitial'
            : ''
        }${allShown ? ' TournamentLegendTableAllShown' : ''}`}
        style={
          allShown
            ? {
                height: `${38 * (legendsFormatTableData.length + 1)}px`,
                overflow: 'auto',
                transformOrigin: 'top',
                transition: 'all 0.2s ease-in-out',
              }
            : {}
        }
        columns={columns}
        dataSource={legendsFormatTableData}
      />

      {legendsFormatTableData.length > 4 && (
        <Button
          type="text"
          className="TournamentLegendTableButton flex__shrink-fixed"
          onClick={handleAllShownButtonClick}
        >
          <UpOutlined
            className={`TournamentLegendTableButtonIcon ${
              allShown ? 'TournamentLegendTableCollapseButtonIcon' : ''
            }`}
          />
          <span>{allShown ? '收起' : '全部'}</span>
        </Button>
      )}
    </section>
  );
};

TournamentLegend.displayName = 'TournamentLegend';

export default TournamentLegend;
